   function openTabs(evt, tabName) {
     if(tabName=='all'){
       window.location.href = "https://onlyearthweb.myshopify.com/collections/all";
       return; 
     }
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("cs-copy-content");
    for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
    }